import { CircularProgress } from '@mui/material';

import { IBaseButtonLoaderProps } from '../../feedback-ui/feedback-ui.types';

function BaseButtonLoader({ status: isLoading, size, className }: IBaseButtonLoaderProps) {
  return isLoading ? <CircularProgress className={className} size={size || 20} /> : null;
}

export default BaseButtonLoader;
